/// <reference path="D:\Development\Bayleys\Bayleys Web\src\Bayleys.Search.Web\public/scripts/jquery-bundle.min.js" />

function loadLocaleOptions(elId, data, defaultOpt, clearAll) {
    var options = $('#' + elId + ' option');
    var count = options.length;
    if (count > 1 || clearAll === true)
        for (var i = clearAll === true ? 0 : 1; i < count; i++) {
            $(options[i]).remove();
        }

    $.each(data, function (index, value) {
        $('#' + elId).append($('<option value="' + this.Id + '">' + this.Name + '</option>'));
    });

    $('#' + elId).val(defaultOpt);
}

function loadPropertyTypeOptions(url) {
    $.get(
        url,
        function (data) {
            var options = $('[name="propertyTypesSelect"] option');
            var count = options.length;
            if (count > 0)
                for (var i = 0; i < count; i++) {
                    $(options[i]).remove();
                }

            $.each(data, function (index, value) {
                $('[name="propertyTypesSelect"]').append($('<option value="' + this.Bitwise + '">' + this.Description + '</option>'));
            });

            $('#propertyTypes').val('');
            $('[name="propertyTypesSelect"]').val('').multiselect('deselectAll', true).multiselect('rebuild');
        });
}

function disableElement(elId) {
    var el = $('#' + elId);
    $(el).addClass('hide');
    $(el).find('input, select').attr('disabled', 'disabled');
    $(el).find('select').multiselect('rebuild');
}

function enableElement(elId) {
    var el = $('#' + elId);
    $(el).removeClass('hide');
    $(el).find('input, select').removeAttr('disabled');
    $(el).find('select').multiselect('rebuild');
}

function resetLandArea() {
    $('#landAreaHectares h4').text('Land Area');
    $('#landAreaSquareMetres h4').text('Land Area');
}

// function setMinMaxPriceDropdownText(type) {
//   if ($('#home').length > 0) {
//     $('#minPrice option[value=""]').text('Min Price ' + type);
//     $('#maxPrice option[value=""]').text('Max Price ' + type);
//   }
//}

function getSearchType() {
    var value,
        searchTypeTagName = $('#searchType:enabled').prop('tagName');
    if (searchTypeTagName === undefined)
        return false;
    if (searchTypeTagName.toLowerCase() === 'select') {
        value = $('select#searchType').val();
    } else {
        value = $('input#searchType:checked').val();
    }
    return value;
}

function isSearchTypeVisible() {
    var searchTypeTagName = $('[name="searchType"]:visible').prop('tagName');
    if (searchTypeTagName === undefined)
        return false;
    if (searchTypeTagName.toLowerCase() === 'select') {
        return $('select#searchType').is(':visible');
    } else {
        return $('input#searchType:checked').is(':visible');
    }
}

function setSearchType(value) {
    var searchTypeTagName = $('#searchType').prop('tagName');
    if (searchTypeTagName.toLowerCase() === 'select') {
        $('#searchType').val(value);
    } else {
        var searchTypes = $('.tabbed-search-types label');
        searchTypes.removeClass('checked');
        searchTypes.children('input[type="radio"]').prop('checked', false);
        var input = searchTypes.children('input[type="radio"][value="' + value + '"]');
        input.prop('checked', true);
        input.parent('label').addClass('checked');

        loadSearchType();
    }
    return value;
}

function canDisable() {
    $('input.can-disable:hidden, select.can-disable:hidden').attr('disabled', 'disabled');
    $('input.can-disable:visible, select.can-disable:visible').removeAttr('disabled');
}

function showHidePrices() {
    var searchType = getSearchType();
    var listingType = $('input:radio[name="listingType"]:checked').val();
    if ((searchType === 'Residential') && (listingType === 'Rent' || listingType === 'Rental' || listingType === 'RentalLease')) {
        disableElement('price');
        disableElement('leasePrice');
        enableElement('rentalPrice');
        disableElement('ifEverything');
        $('.search-options .listing-type').text(' for rent ');
    } else if (searchType === 'Commercial' && (listingType === 'Lease' || listingType === 'Rent' || listingType === 'Rental' || listingType === 'RentalLease')) {
        disableElement('price');
        disableElement('rentalPrice');
        enableElement('leasePrice');
        disableElement('ifEverything');
        $('.search-options .listing-type').text(' for lease ');
        $('#investmentTypeIds').multiselect('deselectAll', true).multiselect('disable');
        loadPropertyTypeOptions('/property-types/commercial/lease');
    } else if ((searchType === 'Residential' || searchType === 'Commercial' || searchType === 'Lifestyle' || searchType === 'Business' || searchType === 'Rural') && (listingType === 'Sale' || listingType === 'None')) {
        disableElement('leasePrice');
        disableElement('rentalPrice');
        enableElement('price');
        disableElement('ifEverything');
        $('.search-options .listing-type').text('');
        $('#investmentTypeIds').multiselect('deselectAll', true).multiselect('enable');
        if (listingType === 'Sale') {
            $('.search-options .listing-type').text(' for sale ');
        }
        if (searchType === 'Commercial') {
            enableElement('landAreaSquareMetres');
            loadPropertyTypeOptions('/property-types/commercial');
        }
    } else {
        disableElement('leasePrice');
        disableElement('rentalPrice');
        disableElement('price');
        enableElement('ifEverything');
        $('.search-options .listing-type').text('');
    }
}

function configureEverything() {
    $('#rentLeaseSpan').text('Rent/Lease');
    disableElement('listingTypes');
    disableElement('beds');
    disableElement('bathrooms');
    disableElement('residentialParking');
    disableElement('otherParking');
    disableElement('landAreaHectares');
    disableElement('landAreaSquareMetres');
    disableElement('floorAreaSquareMetres');
    disableElement('propertyTypesContainer');
    disableElement('investmentTypes');
    disableElement('businessGroups');
    disableElement('propertyTypesContainerCommercial');
    $('#otherParking p small').text('Commercial parking');
    $('#residentialParking p small').text('Residential parking');
    $('.search-options .search-type').text(' in everything ');
    loadPropertyTypeOptions('/property-types');
}

function configureResidential() {
    $('.search-options .search-type').text(' in residential ');
    $('#rentLeaseSpan').text('Rental');
    enableElement('listingTypes');
    enableElement('beds');
    enableElement('bathrooms');
    enableElement('residentialParking');
    enableElement('propertyTypesContainer');
    disableElement('landAreaHectares');
    disableElement('landAreaSquareMetres');
    disableElement('floorAreaSquareMetres');
    disableElement('businessGroups');
    disableElement('investmentTypes');
    disableElement('propertyTypesContainerCommercial');
    disableElement('otherParking');
    resetLandArea();
    loadPropertyTypeOptions('/property-types/residential');
}

function configureLifestyle() {
    $('.search-options .search-type').text(' in lifestyle ');
    enableElement('beds');
    enableElement('bathrooms');
    enableElement('landAreaHectares');
    enableElement('propertyTypesContainer');
    disableElement('listingTypes');
    disableElement('landAreaSquareMetres');
    disableElement('floorAreaSquareMetres');
    disableElement('residentialParking');
    disableElement('businessGroups');
    disableElement('investmentTypes');
    disableElement('propertyTypesContainerCommercial');
    disableElement('otherParking');
    resetLandArea();
    loadPropertyTypeOptions('/property-types/lifestyle');
}

function configureRural() {
    $('.search-options .search-type').text(' in rural ');
    enableElement('beds');
    enableElement('bathrooms');
    enableElement('landAreaHectares');
    enableElement('propertyTypesContainer');
    disableElement('listingTypes');
    disableElement('landAreaSquareMetres');
    disableElement('floorAreaSquareMetres');
    disableElement('residentialParking');
    disableElement('businessGroups');
    disableElement('investmentTypes');
    disableElement('propertyTypesContainerCommercial');
    disableElement('otherParking');
    resetLandArea();
    loadPropertyTypeOptions('/property-types/rural');
}

function configureCommercial() {
    $('.search-options .search-type').text(' in commercial ');
    $('#rentLeaseSpan').text('Lease');
    enableElement('listingTypes');
    enableElement('propertyTypesContainerCommercial');
    enableElement('floorAreaSquareMetres');
    enableElement('landAreaSquareMetres');
    enableElement('investmentTypes');
    enableElement('otherParking');
    disableElement('beds');
    disableElement('bathrooms');
    disableElement('landAreaHectares');
    disableElement('residentialParking');
    disableElement('businessGroups');
    disableElement('propertyTypesContainer');
    resetLandArea();
    loadPropertyTypeOptions('/property-types/commercial');
}

function configureBusiness() {
    $('.search-options .search-type').text(' in business ');
    disableElement('listingTypes');
    disableElement('landAreaHectares');
    disableElement('floorAreaSquareMetres');
    disableElement('landAreaSquareMetres');
    disableElement('beds');
    disableElement('bathrooms');
    disableElement('residentialParking');
    disableElement('propertyTypesContainer');
    disableElement('investmentTypes');
    disableElement('propertyTypesContainerCommercial');
    enableElement('businessGroups');
    disableElement('otherParking');
    resetLandArea();
    loadPropertyTypeOptions('/property-types/business/' + $('#businessGroups option:selected').val());
}

function loadSearchType() {
    var value = getSearchType();
    $('#searchOptions').removeClass('Residential')
        .removeClass('Lifestyle')
        .removeClass('Rural')
        .removeClass('Commercial')
        .removeClass('Business')
        .removeClass('Everything')
        .addClass(value);
    switch (value) {
        case 'Residential':
            configureResidential();
            break;
        case 'Lifestyle':
            configureLifestyle();
            break;
        case 'Rural':
            configureRural();
            break;
        case 'Commercial':
            configureCommercial();
            break;
        case 'Business':
            configureBusiness();
            break;
        default:
            configureEverything();
            break;
    }
    // canDisable();
    showHidePrices();
}

function hasQueryString() {
    var field = 'searchtype';
    var url = window.location.href.toLowerCase();
    if (url.indexOf('?' + field + '=') != -1)
        return true;
    else if (url.indexOf('&' + field + '=') != -1)
        return true;
    return false;
}

function setDefaultOptions() {
    if ($('#home').length > 0 && $('input[name="searchType"][value="Everything"]:visible').length === 0) {
        // setMinMaxPriceDropdownText("Buy");
        $('#minNoBedrooms option[value=""]').text('Min Beds');
        $('#maxNoBedrooms option[value=""]').text('Max Beds');
        $('#minLandAreaHectares option[value=""]').text('Min Area');
        $('#maxLandAreaHectares option[value=""]').text('Max Area');
        $('#minFloorArea option[value=""]').text('Min Floor Area');
        $('#maxFloorArea option[value=""]').text('Max Floor Area');
    } else if ($('#home').length > 0) {
        $('#minPrice option[value=""]').text('Select');
        $('#maxPrice option[value=""]').text('Select');
        $('#minNoBedrooms option[value=""]').text('Select');
        $('#maxNoBedrooms option[value=""]').text('Select');
        $('#minLandAreaHectares option[value=""]').text('Select');
        $('#maxLandAreaHectares option[value=""]').text('Select');
        $('#minFloorArea option[value=""]').text('Select');
        $('#maxFloorArea option[value=""]').text('Select');
    }
    $('#newSearch').show();
    // canDisable();
}

function resizeWindow() {
    waitForFinalEvent(function () {
        setDefaultOptions();
        if (!isSearchTypeVisible() && getSearchType() === 'Everything') {
            loadSearchType();
        }
    });
}

resizeWindow();

$(document).ready(function () {
    jQuery.event.add(window, "resize", resizeWindow);

    $('#searchForm, #newSearchForm').find($('input, select')).each(function () {
        var $this = $(this);
        if ($this.val() !== null && $this.val().length > 0) {
            $this.addClass('had-data');
        }
    });

    $('#regionId').multiselect({
        maxHeight: 300,
        buttonContainer: '<div class="btn-group megamenu btn-block" translate="no"></div>',
        buttonClass: 'btn btn-sm btn-default btn-outline',
        buttonWidth: '100%',
        disableIfEmpty: true,
        enableFiltering: true,
        enableCaseInsensitiveFiltering: true,
        templates: {
            ul: '<ul class="multiselect-container dropdown-menu megamenu-fw btn-block" translate="no"></ul>',
            filter: '<li class="multiselect-item multiselect-filter"><div class="input-group"><input class="form-control multiselect-search" type="text" autocomplete="off" spellcheck="false"/></div></li>',
            filterClearBtn: '<span class="input-group-btn"><button class="btn btn-info btn-outline multiselect-clear-filter" type="button" data-toggle="tooltip" title="Clear filters" data-position="top" data-container="body"><svg class="svg svg-icon-close"><use xlink:href="/public/img/svg/symbol-defs.svg#svg-icon-close"></use></svg></button></span>',
        },
        filterPlaceholder: 'Filter regions',
        onChange: function (element, checked) {
            if (checked === true) {
                $('.search-options .location').removeClass('hide');
            } else if (checked === false) {
                $('.search-options .location').addClass('hide');
            }
        },
        onInitialized: function (select, container) {
            if ($('#regionId').hasClass('had-data')) {
                $('.search-options .location').removeClass('hide');
            }
        }
    });

    $('#packageIds').multiselect({
        maxHeight: 300,
        buttonContainer: '<div class="btn-group megamenu btn-block"></div>',
        buttonClass: 'btn btn-sm btn-default btn-outline',
        buttonWidth: '100%',
        disableIfEmpty: true,
        enableFiltering: true,
        enableCaseInsensitiveFiltering: true,
        templates: {
            ul: '<ul class="multiselect-container dropdown-menu megamenu-fw btn-block" translate="no"></ul>',
            filter: '<li class="multiselect-item multiselect-filter"><div class="input-group"><input class="form-control multiselect-search" type="text" autocomplete="off" spellcheck="false"/></div></li>',
            filterClearBtn: '<span class="input-group-btn"><button class="btn btn-info btn-outline multiselect-clear-filter" type="button" data-toggle="tooltip" title="Clear filters" data-position="top" data-container="body"><svg class="svg svg-icon-close"><use xlink:href="/public/img/svg/symbol-defs.svg#svg-icon-close"></use></svg></button></span>',
        },
        filterPlaceholder: 'Filter packages'
    });

    var numberDistricts = $('#districtId option').size();

    $('#districtId').multiselect({
        maxHeight: 300,
        buttonContainer: '<div class="btn-group megamenu btn-block" translate="no"></div>',
        buttonClass: 'btn btn-sm btn-default btn-outline',
        buttonWidth: '100%',
        disableIfEmpty: true,
        disabledText: 'All areas',
        nonSelectedText: 'Select an area',
        enableFiltering: true,
        enableCaseInsensitiveFiltering: true,
        templates: {
            ul: '<ul class="multiselect-container dropdown-menu megamenu-fw btn-block" translate="no"></ul>',
            filter: '<li class="multiselect-item multiselect-filter"><div class="input-group"><input class="form-control multiselect-search" type="text" autocomplete="off" spellcheck="false"/></div></li>',
            filterClearBtn: '<span class="input-group-btn"><button class="btn btn-info btn-outline multiselect-clear-filter" type="button" data-toggle="tooltip" title="Clear filters" data-position="top" data-container="body"><svg class="svg svg-icon-close"><use xlink:href="/public/img/svg/symbol-defs.svg#svg-icon-close"></use></svg></button></span>',
        },
        filterPlaceholder: 'Filter areas'
    });

    if (numberDistricts <= 1) {
        $('#districtId').multiselect('disable');
    }

    $('#suburbIds').multiselect({
        maxHeight: 300,
        buttonContainer: '<div class="btn-group megamenu btn-block" translate="no"></div>',
        buttonClass: 'btn btn-sm btn-default btn-outline',
        buttonWidth: '100%',
        disableIfEmpty: true,
        disabledText: 'All suburbs',
        allSelectedText: 'All suburbs selected',
        nonSelectedText: 'Select a suburb',
        enableFiltering: true,
        enableCaseInsensitiveFiltering: true,
        includeSelectAllOption: true,
        templates: {
            ul: '<ul class="multiselect-container dropdown-menu megamenu-fw btn-block" translate="no"></ul>',
            filter: '<li class="multiselect-item multiselect-filter"><div class="input-group"><input class="form-control multiselect-search" type="text" autocomplete="off" spellcheck="false"/></div></li>',
            filterClearBtn: '<span class="input-group-btn"><button class="btn btn-info btn-outline multiselect-clear-filter" type="button" data-toggle="tooltip" title="Clear filters" data-position="top" data-container="body"><svg class="svg svg-icon-close"><use xlink:href="/public/img/svg/symbol-defs.svg#svg-icon-close"></use></svg></button></span>',
        },
        filterPlaceholder: 'Filter suburbs'
    });

    $('#investmentTypeIds').multiselect({
        maxHeight: 300,
        buttonContainer: '<div class="btn-group megamenu btn-block" translate="no"></div>',
        buttonClass: 'btn btn-sm btn-default btn-outline',
        buttonWidth: '100%',
        disableIfEmpty: true,
        disabledText: 'All investment types',
        allSelectedText: 'All investment types selected',
        nonSelectedText: 'Select an investment type',
        templates: {
            ul: '<ul class="multiselect-container dropdown-menu megamenu-fw btn-block" translate="no"></ul>',
        }
    });

    $('#regionId').change(function (e) {
        var regionId = $(this).val();
        if (regionId !== '') {
            $.get(
                '/locales/districts/' + regionId,
                function (districts, status) {
                    loadLocaleOptions('districtId', districts, '', false);
                    loadLocaleOptions('suburbIds', [], 'All Suburbs', true);
                    $('#districtId, #suburbIds').multiselect('deselectAll', true).multiselect('rebuild');
                });
        } else {
            loadLocaleOptions('districtId', [], '', false);
            loadLocaleOptions('suburbIds', [], 'All Suburbs', true);
            $('#districtId, #suburbIds').multiselect('deselectAll', true).multiselect('rebuild');
        }
    });

    $('#districtId').change(function (e) {
        var districtId = $(this).val();
        $.get(
            '/locales/suburbs/' + districtId,
            function (suburbs, status) {
                loadLocaleOptions('suburbIds', suburbs, 'All Suburbs', true);
                $('#suburbIds').multiselect('deselectAll', true).multiselect('rebuild');
            });
    });

    $('#listingTypes .btn').click(function (e) {
        var listingTypes = $('#listingTypes');
        listingTypes.children('input[type="radio"]').prop('checked', false);
        $(this).children('input[type="radio"]').prop('checked', true);

        showHidePrices();
    });

    $('.search-type-dropdown').multiselect({
        buttonContainer: '<div class="btn-group btn-block"></div>',
        buttonClass: 'btn btn-default btn-lg btn-block',
        templates: {
            button: '<button type="button" class="multiselect dropdown-toggle" data-toggle="dropdown" tabindex="2" accesskey="t"><span class="multiselect-selected-text"></span> <b class="caret"></b></button>',
            ul: '<ul class="multiselect-container dropdown-menu megamenu-fw btn-block"></ul>'
        }
    });

    $('.basic-dropdown').multiselect({
        maxHeight: 300,
        buttonClass: 'btn btn-sm btn-default btn-outline',
        templates: {
            ul: '<ul class="multiselect-container dropdown-menu megamenu-fw btn-block"></ul>'
        }
    });

    $('.cost-dropdown').multiselect({
        maxHeight: 300,
        buttonClass: 'btn btn-sm btn-default btn-outline',
        templates: {
            ul: '<ul class="multiselect-container dropdown-menu megamenu-fw btn-block"></ul>'
        },
        onChange: function (element, checked) {
            if (checked === true) {
                $('.search-options .cost').removeClass('hide');
            } else if (checked === false) {
                $('.search-options .cost').addClass('hide');
            }
        },
        onInitialized: function (select, container) {
            if ($('.cost-dropdown').hasClass('had-data')) {
                $('.search-options .cost').removeClass('hide');
            }
        }
    });

    $('.bedrooms-dropdown').multiselect({
        buttonClass: 'btn btn-sm btn-default btn-outline',
        templates: {
            ul: '<ul class="multiselect-container dropdown-menu megamenu-fw btn-block"></ul>'
        },
        onChange: function (element, checked) {
            if (checked === true) {
                $('.search-options .bedrooms').removeClass('hide');
            } else if (checked === false) {
                $('.search-options .bedrooms').addClass('hide');
            }
        },
        onInitialized: function (select, container) {
            if ($('.bedrooms-dropdown').hasClass('had-data')) {
                $('.search-options .bedrooms').removeClass('hide');
            }
        }
    });

    $('.bathrooms-dropdown').multiselect({
        buttonClass: 'btn btn-sm btn-default btn-outline btn-block',
        buttonContainer: '<div></div>',
        templates: {
            ul: '<ul class="multiselect-container dropdown-menu megamenu-fw btn-block"></ul>'
        },
        onChange: function (element, checked) {
            if (checked === true) {
                $('.search-options .bathrooms').removeClass('hide');
            } else if (checked === false) {
                $('.search-options .bathrooms').addClass('hide');
            }
        },
        onInitialized: function (select, container) {
            if ($('.bathrooms-dropdown').hasClass('had-data')) {
                $('.search-options .bathrooms').removeClass('hide');
            }
        }
    });

    $('.residential-parking-dropdown').multiselect({
        buttonClass: 'btn btn-sm btn-default btn-outline btn-block',
        buttonContainer: '<div></div>',
        templates: {
            ul: '<ul class="multiselect-container dropdown-menu megamenu-fw btn-block"></ul>'
        },
        onChange: function (element, checked) {
            if (checked === true) {
                $('.search-options .residential-parking').removeClass('hide');
            } else if (checked === false) {
                $('.search-options .residential-parking').addClass('hide');
            }
        },
        onInitialized: function (select, container) {
            if ($('.residential-parking-dropdown').hasClass('had-data')) {
                $('.search-options .residential-parking').removeClass('hide');
            }
        }
    });

    $('.commercial-parking-dropdown').multiselect({
        buttonClass: 'btn btn-sm btn-default btn-outline btn-block',
        buttonContainer: '<div></div>',
        templates: {
            ul: '<ul class="multiselect-container dropdown-menu megamenu-fw btn-block"></ul>'
        },
        onChange: function (element, checked) {
            if (checked === true) {
                $('.search-options .commercial-parking').removeClass('hide');
            } else if (checked === false) {
                $('.search-options .commercial-parking').addClass('hide');
            }
        },
        onInitialized: function (select, container) {
            if ($('.commercial-parking-dropdown').hasClass('had-data')) {
                $('.search-options .commercial-parking').removeClass('hide');
            }
        }
    });

    $('.area-dropdown').multiselect({
        buttonClass: 'btn btn-sm btn-default btn-outline btn-block',
        templates: {
            ul: '<ul class="multiselect-container dropdown-menu megamenu-fw btn-block"></ul>'
        },
        onChange: function (element, checked) {
            if (checked === true) {
                $('.search-options .area').removeClass('hide');
            } else if (checked === false) {
                $('.search-options .area').addClass('hide');
            }
        },
        onInitialized: function (select, container) {
            if ($('.area-dropdown').hasClass('had-data')) {
                $('.search-options .area').removeClass('hide');
            }
        }
    });

    $('#businessGroupIds').multiselect({
        buttonClass: 'btn btn-sm btn-default btn-outline btn-block',
        buttonWidth: '100%',
        templates: {
            ul: '<ul class="multiselect-container dropdown-menu megamenu-fw btn-block"></ul>'
        },
        onChange: function (element, checked) {
            if (checked === true) {
                $('.search-options .business').removeClass('hide');
                loadPropertyTypeOptions('/property-types/business/' + $(element).val());
            } else if (checked === false) {
                $('.search-options .business').addClass('hide');
                loadPropertyTypeOptions('/property-types/business');
            }
        },
        onInitialized: function (select, container) {
            if ($('.area-dropdown').hasClass('had-data')) {
                $('.search-options .business').removeClass('hide');
            }
        }
    });

    $('[name="propertyTypesSelect"]').multiselect({
        maxHeight: 300,
        buttonContainer: '<div class="btn-group megamenu btn-block"></div>',
        buttonClass: 'btn btn-sm btn-default btn-outline',
        buttonWidth: '100%',
        enableFiltering: true,
        enableCaseInsensitiveFiltering: true,
        templates: {
            ul: '<ul class="multiselect-container dropdown-menu megamenu-fw btn-block"></ul>',
            filter: '<li class="multiselect-item multiselect-filter"><div class="input-group"><input class="form-control multiselect-search" type="text" autocomplete="off" spellcheck="false"/></div></li>',
            filterClearBtn: '<span class="input-group-btn"><button class="btn btn-info btn-outline multiselect-clear-filter" type="button" data-toggle="tooltip" title="Clear filters" data-position="top" data-container="body"><svg class="svg svg-icon-close"><use xlink:href="/public/img/svg/symbol-defs.svg#svg-icon-close"></use></svg></button></span>',
        },
        filterPlaceholder: 'Filter listing types',
        numberDisplayed: 6,
        allSelectedText: 'All property types',
        onChange: function (element, checked) {
            if (checked === true) {
                $('.search-options .property-type').removeClass('hide');
            } else if (checked === false) {
                $('.search-options .property-type').addClass('hide');
            }
        },
        onInitialized: function (select, container) {
            if ($('[name="propertyTypesSelect"]').hasClass('had-data')) {
                $('.search-options .property-type').removeClass('hide');
            }
        }
    });

    $('[name="propertyTypesSelect"]').change(function (e) {
        var selectedPropertyTypes = $(this).children('option:selected');
        var bitwise = 0;
        for (var i = 0; i < selectedPropertyTypes.length; i++) {
            bitwise += parseFloat($(selectedPropertyTypes[i]).val());
        }
        if (bitwise === 0)
            $('[name="propertyTypes"]').val('');
        else
            $('[name="propertyTypes"]').val(bitwise);
    });

    $('select#searchType').change(function () {
        loadSearchType();
    });

    $('#sortOrder').change(function () {
        $('#orderType').val($(this).val());
        $('form#newSearchForm').submit();
    });

    $('#searchForm, #newSearchForm').on('submit', function (event) {

        var minPrice = parseInt($('#minPrice option:selected').val()),
            maxPrice = parseInt($('#maxPrice option:selected').val());

        if (minPrice > maxPrice)
            $('#minPrice').val(maxPrice);
        if (maxPrice < minPrice)
            $('#maxPrice').val(minPrice);

        if ($(this).hasClass('reporting-search')) {
            if ($(this).data('tabletorefresh')) {
                $('#' + $(this).data('tabletorefresh')).bootstrapTable('refresh');
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: $(".result-details-container").offset().top
                }, 2000);
                return false;
            }
        }

        loadSearchType();

        $('[name="propertyTypesSelect"]').attr('disabled', 'disabled');

        $(this).find('input, select').each(function () {
            var $this = $(this);
            var attr = $this.attr('disabled');
            if (typeof attr === typeof undefined || attr === false) {
                if (!$this.is(':visible') && !$this.hasClass('do-not-disable') && !$this.is(':hidden')) {
                    $this.attr('disabled', 'disabled');
                } else if (($this.val() === null || ($this.val() !== null && $this.val().length === 0))) {
                    $this.attr('disabled', 'disabled');
                }
            }
        });
    });

    showHidePrices();
});